<template>
  <div class="tomb_page">
    <div
      class="head-topbar lite-page-top linebottom sticky"
      style="background: rgb(255, 255, 255);"
    >
      <div class="topbar-left" @click="$router.go(-1)"><i class="icon-arrow-left"></i></div>
      <div class="topbar-main"><h4>亲友团管理</h4></div>
      <div class="topbar-right"></div>
    </div>
    <div>
      <div class="adm-pull-to-refresh">
        <div class="family-list">
          <div style="padding-top:2rem;">
            <div class="item" v-for="(item,index) in friendList" :key="index">
              <div class="item-headimg">
                <img :src="item.myProfile.headImgUrl" />
              </div>
              <div class="item-desc">
                <div class="head flex-between">
                  <div style="display: flex;">
                    <div class="name">
                      <span>{{item.myProfile.nickname}}</span>
                    </div>
                    <div class="relation status-green" v-if="$properties(item.category, 'value')=='member'">亲友</div>
                    <div class="relation status-gray" v-else-if="$properties(item.category, 'value')=='admin'">管理员</div>
                  </div>
                </div>
                <div class="time">加入时间：{{fmtDateTime(item.createDate)}}</div>
              </div>
              <div v-if="hallInfo.myId==$store.getters.userId" class="delFriend" @click="deleteFriend(item.id)"></div>
            </div>
          </div>
          <div class="adm-infinite-scroll">
            <div><span>没有更多数据了</span></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'friends',
  data() {
    return {
      hallId: null,
      hallInfo:{
        id: null,
        myId: null,
      },
      friendList:[],
      friendTotal: 0,
    }
  },
  methods: {
    goto(str) {
      this.$router.push({ path: str })
    },
    fmtDateTime(value) {
      if (value) {
        return moment(value, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm')
      } else {
        return ''
      }
    },
    queryHallOne(){
      var that = this
      this.$queryOne('HallInfo', {id:this.hallId}, this.hallInfo, function(res) {
        that.hallInfo = res.data
      })
    },
    queryFriendAll(){
      var that = this
      this.$queryPage('HallFriend', {hallId:this.hallId,'myProfile.headImgUrl':'isnotnull'}, function(res) {
        that.friendList = res.data
        that.friendTotal = res.total
      })
    },
    deleteFriend(id){
      var that = this
      this.$dialog
        .confirm({
          message: '是否确认删除？',
        })
        .then(() => {
          that.$invalid('HallFriend', {id:id}, function(res) {
            if(res.code==1){
              that.queryFriendAll()
            }
          })
        })
        .catch(() => {
          // on cancel
        })
    }
  },
  mounted() {
    this.hallId = this.$route.params.id
    this.queryHallOne()
    this.queryFriendAll()
  },
  created() {},
}
</script>

<style>
.delFriend {
  position: absolute;
  right: 2rem;
  top: 2rem;
  width: 1.91rem;
  height: 1.91rem;
  background: url(../../assets/jnt/del.png) no-repeat;
  background-size: 100% 100%;
}
.head-topbar {
  display: flex;
  align-items: center;
  height: 3.8rem;
  background: #fff;
  position: fixed;
  width: 100%;
  z-index: 1;
}

.head-topbar.sticky {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
}

.head-topbar.fixed {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
}

.head-topbar .topbar-left {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 6.73333vw;
  position: absolute;
  left: 0.265rem;
  height: 100%;
  z-index: 10;
}

.head-topbar .topbar-left .icon-arrow-left {
  background: url(../../assets/jnt/left.png) no-repeat;
  background-size: 100%;
  display: inline-block;
  height: 1.363rem;
  width: 0.818rem;
}

.head-topbar .topbar-right .icon-more {
  background: url(../../assets/jnt/more.png) no-repeat;
  background-size: 100%;
  display: inline-block;
  height: 3.365vw;
  width: 4.125vw;
}

.head-topbar .topbar-main {
  flex: 1;
  color: #333;
  font-size: 1.454rem;
}

.head-topbar .topbar-main,
.head-topbar .topbar-right {
  display: flex;
  justify-content: center;
  align-items: center;
}

.head-topbar .topbar-right {
  padding-right: 1rem;
  position: absolute;
  right: 0.265rem;
  font-size: 1.272rem;
}

.head-topbar .topbar-btn {
  background: #e4803c;
  color: #fff;
  padding: 0.5rem 1.2rem;
  border-radius: 20px;
  font-size: 1.3rem;
}
.adm-infinite-scroll {
  color: var(--adm-color-weak);
  padding: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
}
.family-list {
  padding: 0 12px;
}

.family-list .item {
  display: -ms-flexbox;
  display: flex;
  padding: 15px;
  position: relative;
  text-decoration: none;
  background: #fff;
  border-radius: 7.5px;
  margin-bottom: 0.909rem;
}

.family-list .item .item-headimg {
  background: #eee;
  width: 2.8rem;
  height: 2.8rem;
  border-radius: 50%;
  overflow: hidden;
  position: relative;
}

.family-list .item .item-headimg img {
  width: 100%;
  height: 100%;
}

.family-list .item .item-desc {
  -ms-flex-direction: column;
  -ms-flex-pack: justify;
  -webkit-justify-content: space-between;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: 10px;
  width: calc(100% - 51px);
}

.family-list .item .item-desc .head {
  align-items: center;
  width: 100%;
  display: flex;
  font-size: 15px;
  color: #333;
}

.family-list .item .item-desc .head .name {
  color: #333;
  font-size: 1.3rem;
  margin-right: 5px;
}

.family-list .item .item-desc .head .relation {
  line-height: 17px;
  padding: 0 4px;
  border-radius: 4px;
  font-size: 1rem;
}

.family-list .item .item-desc .head .status-green {
  color: #33ae52;
  border: 1px solid #33ae52;
  margin-right: 5px;
}

.family-list .item .item-desc .head .status-gray {
  background: #e4803c;
  color: #fff;
  border: 1px solid #e4803c;
}

.family-list .item .item-desc .time {
  color: #333;
  font-size: 1.1rem;
  margin-top: 12px;
}

.family-list .item .item-desc .footer {
  margin-top: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.family-list .item .item-desc .footer .bot-counts {
  color: #999;
  font-size: 1.1rem;
  justify-content: center;
}

.family-list .item .item-desc .footer .bot-counts,
.family-list .item .item-desc .footer .bot-counts .love,
.family-list .item .item-desc .footer .bot-counts .view {
  -ms-flex-align: center;
  -ms-flex-pack: center;
  -webkit-align-items: center;
  -webkit-justify-content: center;
  align-items: center;
  display: -ms-flexbox;
  display: flex;
}

.family-list .item .item-desc .footer .bot-counts .love {
  margin-right: 2.272rem;
}

.family-list .item .item-desc .footer .bot-counts .view {
  margin-right: 10px;
}

.family-list .item .item-desc .footer .bot-btn {
  display: flex;
  justify-content: right;
}

.family-list .item .item-desc .footer .bot-btn .del {
  box-sizing: border-box;
  padding: 0 12px;
  line-height: 22px;
  font-size: 1.1rem;
  border-color: #f6523f;
  color: #f6523f;
  border: 1px solid;
  border-radius: 12px;
}

.family-list .item .item-desc .footer .bot-btn .pass {
  box-sizing: border-box;
  padding: 0 12px;
  line-height: 24px;
  font-size: 1.1rem;
  color: #fff;
  border-radius: 12px;
  background: #e4803c;
}

.family-list .item .item-desc .footer .bot-btn .reject {
  color: #999;
  border: 1px solid #999;
  border-radius: 12px;
  padding: 0 11px;
  line-height: 22px;
  box-sizing: border-box;
  font-size: 1.1rem;
  background: #fff;
  margin-right: 10px;
}

.family-list .item .item-desc .flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
